"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleWrapper = TitleWrapper;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cssModifierUtilities = require("../utilities/cssModifierUtilities");

var _HorizontalFlex = require("./HorizontalFlex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var componentModifiers = ['align-center', 'space-between', 'small-relative'];

function renderIcon(iconClass) {
  if (!iconClass) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "title-wrapper__icon ".concat(iconClass)
  });
}

function TitleWrapper(_ref) {
  var iconClass = _ref.iconClass,
      leftComponent = _ref.leftComponent,
      cssClassModifiers = _ref.cssClassModifiers,
      rightComponent = _ref.rightComponent,
      title = _ref.title;
  var className = (0, _cssModifierUtilities.buildClassName)('title-wrapper', cssClassModifiers);

  if (leftComponent) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: className
    }, /*#__PURE__*/_react["default"].createElement(_HorizontalFlex.HorizontalFlex, {
      cssClassModifiers: ['align-center', 'flex-wrap']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "title-wrapper__title"
    }, renderIcon(iconClass), title), /*#__PURE__*/_react["default"].createElement(_HorizontalFlex.HorizontalFlex, {
      cssClassModifiers: componentModifiers
    }, leftComponent, rightComponent)));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_HorizontalFlex.HorizontalFlex, {
    cssClassModifiers: componentModifiers
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "title-wrapper__title"
  }, renderIcon(iconClass), title), rightComponent));
}

TitleWrapper.propTypes = {
  title: _propTypes["default"].string.isRequired,
  cssClassModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string),
  iconClass: _propTypes["default"].string,
  leftComponent: _propTypes["default"].node,
  rightComponent: _propTypes["default"].node
};
TitleWrapper.defaultProps = {
  cssClassModifiers: [],
  iconClass: undefined,
  leftComponent: undefined,
  rightComponent: undefined
};